import { ReactComponent as FlagIcon } from "./svg/no-flag.svg";
import "../flag-icon.scss";

export const NOFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
